import secp256k1 from 'secp256k1/elliptic';
import createKeccakHash from 'keccak/js';

/*Functions extracted from Keythereum 
https://github.com/ethereumjs/keythereum
to reduce the size of the bundle
*/

export function privateKeyToAddress(privateKey) {
  var privateKeyBuffer, publicKey;
  privateKeyBuffer = str2buf(privateKey);
  if (privateKeyBuffer.length < 32) {
    privateKeyBuffer = Buffer.concat([
      Buffer.alloc(32 - privateKeyBuffer.length, 0),
      privateKeyBuffer,
    ]);
  }
  publicKey = secp256k1.publicKeyCreate(privateKeyBuffer, false).slice(1);
  return (
    '0x' +
    keccak256(publicKey)
      .slice(-20)
      .toString('hex')
  );
}

function str2buf(str, enc) {
  if (!str || str.constructor !== String) return str;
  if (!enc && this.isHex(str)) enc = 'hex';
  if (!enc && this.isBase64(str)) enc = 'base64';
  return Buffer.from(str, enc);
}

export function keccak256(buffer) {
  return createKeccakHash('keccak256')
    .update(buffer)
    .digest();
}



// WEBPACK FOOTER //
// ./src/store/features/auth/airbitz-helpers.js